import { o as o_util } from "../chunks/common-namespaces-client-DhfOpdyM.mjs";
import { o as otto } from "../chunks/common-nexus-client-CdICzBNm.mjs";
const dom = o_util.dom ?? {};
const domSync = o_util.dom ?? {};
const stringToDocumentFragment = dom.stringToDocumentFragment;
const getFirstElementByTagName = dom.getFirstElementByTagName;
const getHeadElement = dom.getHeadElement;
const getBodyElement = dom.getBodyElement;
const domAsync = otto.dom ?? {};
const onLoad = domAsync.onLoad;
const onReady = domAsync.onReady;
const onMount = domAsync.onMount;
const onUnmount = domAsync.onUnmount;
export {
  dom,
  domAsync,
  domSync,
  getBodyElement,
  getFirstElementByTagName,
  getHeadElement,
  onLoad,
  onMount,
  onReady,
  onUnmount,
  stringToDocumentFragment
};
/*🤫*/
